export const identify = (x) => x;
export function curry(fn, length = fn.length) {
    const currified = (...args) => {
        if (args.length === 0) {
            return currified;
        }
        if (args.length >= length) {
            return fn(...args);
        }
        const boundFn = fn.bind(fn, ...args);
        return curry(boundFn, length - args.length);
    };
    return currified;
}
export function pipe(fn, ...fns) {
    const { length } = fns;
    return (...args) => {
        let result = fn(...args);
        for (let i = 0; i < length; i++) {
            result = fns[i](result);
        }
        return result;
    };
}
